module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.3e1f08fc.jpg";